import { render } from "./citizenAddModal.vue?vue&type=template&id=4cfbed08&ts=true"
import script from "./citizenAddModal.vue?vue&type=script&lang=ts"
export * from "./citizenAddModal.vue?vue&type=script&lang=ts"

import "./citizenAddModal.vue?vue&type=style&index=0&id=4cfbed08&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__